import getName from "./getName";
import getDescription from "./getDescription";
import routing from "../../front/routing";
import { coverHost } from "../../front/paths";
import { defaultCover } from "../parameters";
import { IPlan } from "../types";
import { IntlShape } from "react-intl";

export default (plan: IPlan, intl: Partial<IntlShape>, publicView?: boolean, pathname?: string) => {
    const name = getName(plan.name, intl);
    const nameSeo = getName(plan.name, intl);
    const description = getDescription(plan.description, intl);
    const descriptionSeo = getDescription(plan.description, intl);
    const composer =
        plan?.meta?.opus?.composer && plan.meta.opus.composer !== "unknown" ? plan.meta.opus.composerName + ": " : "";

    let noindex = true;
    if (publicView && pathname!.length === routing.publicPlan.length + 2 + 24) {
        noindex = false;
    }
    return {
        title: composer + name,
        ogTitle: composer + nameSeo,
        description: description.replace(/<br\/>/g, " \n"),
        ogDescription: descriptionSeo.replace(/<br\/>/g, " \n"),
        type: "article",
        nofollow: true,
        noindex,
        image: plan.cover ? `${coverHost}${plan.cover}` : `${coverHost}${defaultCover}-${intl.locale}.jpg`,
    };
};
